export const sanitizeTemplate = (templateData, account, consentSolutionName) => {
  delete templateData['@id'];
  delete templateData['id'];
  delete templateData['@type'];
  delete templateData['date'];
  delete templateData['originId'];
  delete templateData['@context'];
  templateData.account = account;
  templateData.name = `${consentSolutionName} - ${templateData.name}`;

  return templateData;
};
